import BackLink from '../components/BackLink'
import BottomButton from '../components/BottomButton'
import { Label } from 'semantic-ui-react'
import Layout from '../components/Layout'
import Play from '../components/Play'
import PropTypes from 'prop-types'
import React from 'react'
import _ from 'lodash'
import { dateTimeFormat } from '../lib/config'
import moment from 'moment'

function PlayLogVideo({ loading, log, exercise, backTo, backTitle, goDoExercise }) {
	if (loading) {
		return false
	}
	const srcUrl = `https://res.cloudinary.com/zinid/video/upload/ac_aac,af_44100,c_fill,f_mp4,g_center,h_640,q_70,vc_h264:main:3.1,w_640/v1498748174/${log.cloudinaryVideoPublicId}.mp4`
	return (
		<Layout.Container>
			<Layout.Sticker>
				<h1>{exercise.title}</h1>
				<BackLink to={backTo} content={backTitle} />
				<Play src={srcUrl} loop />
			</Layout.Sticker>
			<Layout.Viewer>
				Anonymous on {moment.unix(log.when / 1000).format(dateTimeFormat)}
				<div>
					{_.map(log.metrics, (val, metric) =>
						<Label key={metric}>
							{metric}: {val}
						</Label>
					)}
					{_.map(log.tags, tag =>
						<Label key={tag}>
							{tag}
						</Label>
					)}
				</div>

			</Layout.Viewer>
			<Layout.Sticker>
				<BottomButton onClick={goDoExercise} content={`Do ${exercise.title}`} />
			</Layout.Sticker>
		</Layout.Container>
	)
}
PlayLogVideo.propTypes = {
	loading: PropTypes.bool.isRequired,
	backTo: PropTypes.string.isRequired,
	backTitle: PropTypes.string.isRequired,
	goDoExercise: PropTypes.func.isRequired,
	log: PropTypes.object,
	exercise: PropTypes.object
}

export default PlayLogVideo



// WEBPACK FOOTER //
// ./src/pages/PlayLogVideo.js